import { provideMirroredSuperProperties } from "src/app/shared/services/gtm-super-property-mirror.service";

/** Restores questionnaire attribution without changing landing labels. */
export const provideQuestionnaireGtmLabels = () =>
  provideMirroredSuperProperties({
    names: ["questionnaire_experiment", "questionnaire_variant"],
    isMirrorable: (values: Record<string, unknown>) =>
      values["questionnaire_experiment"] ===
        "FAIQ-CORE-30-Remove-Questionnaire" &&
      ["control", "treatment", "excluded"].includes(
        String(values["questionnaire_variant"])
      ),
  });
